import { buildQuery } from '../../../utils/query';

// One query builder for the maintenance list, so paging and searching send the
// same URL: searching used to go through its own constant, and paging through
// one that knew nothing about the search.
const maintenanceListQuery = ({ page = 1, rowsPerPage = 10, searchTerm, startDate, endDate, status } = {}) =>
  buildQuery({
    page,
    page_size: rowsPerPage,
    search_term: searchTerm,
    start_date: startDate,
    end_date: endDate,
    status,
  });

export default {
  GET_MAINTENANCE_RECORDS: (params) => `maintenance/${maintenanceListQuery(params)}`,
  GET_ONSITE_MAINTENANCE_RECORDS: (params) => `maintenance/onsite${maintenanceListQuery(params)}`,
  GET_OFFSITE_MAINTENANCE_RECORDS: (params) => `maintenance/offsite${maintenanceListQuery(params)}`,
  GET_ASSET_MAINTENANCE_RECORDS: ({ id, page = 1, rowsPerPage = 10 }) =>
    `maintenance/?asset_id=${id}&page=${page}&page_size=${rowsPerPage}`,
  GET_MAINTENANCE_RECORD: (id) => `maintenance/${id}`,
  CREATE_MAINTENANCE_RECORD: 'maintenance/',
  // PATCH the request itself: provider (or in-house), type, venue, date, description.
  UPDATE_MAINTENANCE_RECORD: (id) => `maintenance/${id}`,
  CREATE_REPAIR_RECORD: 'maintenance/repairs/',
  UPDATE_REPAIR_RECORD: (id) => `maintenance/repairs/${id}/`,
  DELETE_REPAIR_RECORD: (id) => `maintenance/repairs/${id}/`,
  JOB_CARD: (id) => `maintenance/${id}/job-card/`,
  GET_REPAIR_DETAIL: (id, { page = 1, rowsPerPage = 10 } = {}) =>
    `maintenance/repairs/?maintenance_id=${id}&page=${page}&page_size=${rowsPerPage}`,
  UPDATE_STATUS: (id) => `maintenance/${id}/status`,
  APPROVE_MAINTENANCE: (id) => `maintenance/${id}/approve-maintenance`,
  DECLINE_MAINTENANCE: (id) => `maintenance/${id}/decline-maintenance`,
  RETURN_REQUEST: (id) => `maintenance/${id}/return-request/`,
  ACCEPT_RETURN_REQUEST: (id) => `maintenance/${id}/return-request/accept/`,
  DECLINE_RETURN_REQUEST: (id) => `maintenance/${id}/return-request/decline/`,
  SP_REPAIR_ACCEPTANCE: (id) => `maintenance/${id}/service-provider/accept/`,
  SP_REPAIR_DECLINE: (id) => `maintenance/${id}/service-provider/decline/`,
};
